$(function () {

	// TOPスライダー
	$('.top__slick__slider').slick({
		fade: true,    // fedeオン
		speed: 1500,   // 画像切り替えにかかる時間（ミリ秒）
		autoplaySpeed: 4500,   // 自動スライド切り替え速度
		arrows: false,         // 矢印表示・非表示
		autoplay: true,        // 自動再生
		slidesToShow: 1,       // スライド表示数
		slidesToScroll: 1,     // スライドする数
		infinite: true         // 無限リピート オン・オフ
	})
		.on("afterChange", function (event, slick, currentSlide) {
			switch (currentSlide) {
				case 0:
					// 1枚目2週目以降の秒数
					$(this).slick("slickSetOption", "autoplaySpeed", 4000);
					break;
				default:
					// その他の秒数
					$(this).slick("slickSetOption", "autoplaySpeed", 4000);
					break;
			}
		});

	// 逸品画像
	$('.slick__slider').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
		pauseOnFocus: false,
		pauseOnHover: false,
		slidesToShow: 2,
		responsive: [
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: '10%',
				}
			},
		]
	});
});
